<template>
  <div>
    <!-- Hidden file input for loading data -->
    <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" accept=".json">

    <div v-if="hasGeneralRoute">
      <div>
        <b-button size="sm" variant="info" class="mr-1" :disabled="!canUpdate" @click="updatePreview()">{{ $t('route.updateGeneral') }}</b-button>
        
        <b-button-group size="sm">
          <b-button variant="light" @click="fitToScreen" v-b-tooltip.hover :title="$t('route.fitToScreen')">
            <i class="bi bi-fullscreen"></i>
          </b-button> 
        </b-button-group>

        <b-button-group size="sm">
          <b-button variant="light" @click="saveData" v-b-tooltip.hover :title="$t('editor.save')">
            <i class="bi bi-download"></i>
          </b-button>
          <b-button variant="light" @click="loadData" v-b-tooltip.hover :title="$t('editor.load')">
            <i class="bi bi-upload"></i>
          </b-button>
          <b-button variant="light" @click="clearData" v-b-tooltip.hover :title="$t('editor.clear')">
            <i class="bi bi-trash"></i>
          </b-button>
        </b-button-group>
      </div>

      <b-card v-if="routesStore.generalRoute?.data?.lines?.length > 0" no-body bg-variant="light" class="mt-2 pl-3">
        <b-row>
          <b-col>
            <span class="smt2s">{{ $t('route.totalSegments') }}: {{ routesStore.generalRoute?.data?.lines?.length }}</span><br>
            <span class="smt2s">{{ $t('route.estimatedLength') }}: {{
                (routesStore.generalRoute?.data?.distance * 0.000539957).toFixed(1)
              }} nm</span>
          </b-col>
        </b-row>
      </b-card>

      <div>
        <strong>General route areas</strong>
      </div>
      <!-- @row-clicked="onRowClicked" -->
      <b-table sticky-header select-mode="single" ref="generalRouteTable" id="routes-table" style="max-height: 300px;"
              :items="items" :fields="visible_fields"
              :thead-tr-class="headerClass"
              :tbody-tr-class="rowClass" class="mt-2" primary-key="id"
              >

        <template #cell(index)="data">
          <span class='smt2s'>
            <b>{{ data.item.index }}</b>
          </span>
        </template>

        <template #cell(group)="data">
          <span class='smt2s' @click="onRowNameClicked(data.item, data.index)">
            <b>{{ data.item.group }}</b>
            <div v-if="data.item.hasLimits" class="vessel-limits" style="color: black">
              <strong>Vessel Limits</strong>
              <table>
                <tbody>
                  <tr><td>Length:</td><td>{{ data.item.vesselLimits.length }} m</td></tr>
                  <tr><td>Width:</td><td>{{ data.item.vesselLimits.breadth }} m</td></tr>
                  <tr><td>Height:</td><td>{{ data.item.vesselLimits.height }} m</td></tr>
                  <tr><td>Draught:</td><td>{{ data.item.vesselLimits.draught }} m</td></tr>
                </tbody>
              </table>
            </div>
          </span>
        </template> 

        <template #cell(isExcluded)="data">

          <div v-if="data.item.isExcluded">
            <b-button @click="onRowGroupClicked(data.item, data.index)" size="sm" variant="danger">
              <b-icon icon="x-lg"></b-icon>
            </b-button>
          </div>
          <div v-else-if="data.item.isBypassed">
            <b-button @click="onRowGroupClicked(data.item, data.index)" size="sm" variant="warning">
              <b-icon icon="skip-forward-fill"></b-icon>
            </b-button>
          </div> 
          <div v-else>
            <b-button @click="onRowGroupClicked(data.item, data.index)" size="sm" variant="success">
              <b-icon icon="check-lg"></b-icon>
            </b-button>
          </div>

        </template> 
      </b-table>


      <div v-if="!!excludedZones?.length">
      <div>
        <strong>Excluded areas</strong>
      </div>

      <b-table sticky-header select-mode="single" ref="wptable" id="routes-table" style="max-height: 300px;"
            :items="excludedZones" :fields="excluded_ids_fields"
            :thead-tr-class="headerClass"
            :tbody-tr-class="rowClass" class="mt-2" primary-key="id"
            >

        <template #cell(index)="data">
          <span class='smt2s'>
            <b>{{ data.item.index }}</b>
          </span>
        </template>             
              
        <template #cell(segment)="data">
          <span class='smt2s'  @click="onExcludedZoneClicked(data.item, data.index)">
            <b>{{ data.item.group }}</b>
          </span>
        </template>

        <template #cell(flag)="data">

          <b-button @click="onExcludedRowClicked(data.item, data.index)" size="sm" variant="danger">
            <b-icon icon="x-lg"></b-icon>
          </b-button> 
        </template> 

      </b-table>     

      </div>    
    </div>
    <div v-else>
      <b-button-group size="sm">
        <b-button variant="light" @click="loadData" v-b-tooltip.hover :title="$t('editor.load')">
          <i class="fas fa-upload"></i>
        </b-button>
      </b-button-group>
    </div>
  </div>

</template>

<script>
import {eventBus, routes_map} from "@/main";
import store from "@/store";
import {myAxios} from "@/services/myAxios";
import {useRoutesStore} from "@/stores/routes";
import {mapStores} from "pinia";
import {exportJSON} from "@/utils/loadsave"

export default {
  name: "GraphRouteTable",
  data() {
    return {
      selectedSegment: null
    }
  },
  mounted() {
    eventBus.$off('general-route-segment-selected');
    eventBus.$off('has-general-route-segment-selected');
    eventBus.$off('graph-related-settings-changed');
    eventBus.$off('route-preview-cleared');
    eventBus.$off('graph-route-calculation-begin');
    eventBus.$off('views-routes-initialized');
    eventBus.$off('begin-edit-nogo-zones');
    eventBus.$off('end-edit-nogo-zones');
    
    eventBus.$on('general-route-segment-selected', line => {
      this.selectedSegment = line;
      setTimeout(() => this.scrollToSelectedItem(), 50);
    });

    eventBus.$on('has-general-route-segment-selected', result => {
      result.hasSelected = !!this.selectedSegment;
    });

    eventBus.$on('graph-related-settings-changed', () => {
      this.setCanUpdate(true);
    });

    eventBus.$on('begin-edit-nogo-zones', (zones) => {
      this.setCanUpdate(false);
    });

    eventBus.$on('end-edit-nogo-zones', (zones) => {
      this.setCanUpdate(false);
    });

    eventBus.$on('save-nogo-zones', (zones) => {
      this.setCanUpdate(true);
    });

    eventBus.$on('route-preview-cleared', () => {
      this.setCanUpdate(false);
    })

    eventBus.$on('graph-route-calculation-begin', () => {
      this.setCanUpdate(false);
    });

    eventBus.$on('views-routes-initialized', () => {
      this.setCanUpdate(false);
    });
  },
  watch: {},
  computed: {
    ...mapStores(useRoutesStore),
    canUpdate() {
      const routesStore = useRoutesStore();
      return !!routesStore.generalRoute?.isModified;
    },
    hasGeneralRoute() {
      const routesStore = useRoutesStore();
      return !!routesStore.generalRoute?.data;
    },
    headerClass() {
      return "wide-header";
    },
    excludedZones() {
      const routesStore = useRoutesStore();
      const excludedZones = routesStore.generalRoute?.excludedZones || [];
      const currentGroups = (routesStore
        ?.generalRoute
        ?.data
        ?.lines || [])
        .filter(item => item.group && item.group !== "")
        .map(item => item.group)
        ;

      return excludedZones
        .filter(zone => {
          return !currentGroups.includes(zone.group);
        })
        .map((zone, idx) => {
          return {
            index: idx + 1,
            group: zone.group || zone.name,
            segment: zone,
            flag: true
          }
        }); 
    },
    excluded_ids_fields() {
      return [
        {key: 'index', label: '#', tdClass: 'small-black', thClass: 'small-gray'}, 
        {key: 'segment', label: 'Area', tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'flag', label: '', tdClass: 'small-black', thClass: 'small-gray'}, 
      ]
    },
    visible_fields() {
      return [
        {key: 'index', label: '#', tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'group', label: 'Area', tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'isExcluded', label: '', tdClass: 'small-black', thClass: 'small-gray'},
    ]
    },
    items() {
      const routesStore = useRoutesStore();
      if (!routesStore.generalRoute?.data) return [];
      const excludedZones = routesStore.generalRoute?.excludedZones || [];

      const segmentsWithGroup = routesStore
        .generalRoute
        .data
        .lines
        .filter(item => this.selectedSegment?.id == item.id || item.group && item.group !== "");

      const groupSequence = [];
      segmentsWithGroup.forEach(item => {
        if (!groupSequence.length || this.selectedSegment?.id == item.id || groupSequence[groupSequence.length-1].group != item.group) {
          groupSequence.push(item);
        }
      });

      return groupSequence.map(
        (item, idx) => {
          const isExcluded = excludedZones.some(zone => (zone.group && zone.group == item.group));
          const isBypassed = !isExcluded && excludedZones.some(zone => zone.id == item.id);

          return {
            arrayIndex: idx,
            index: idx + 1,
            item: item,
            group: item.group || item.name,
            hasLimits: !!item.vesselLimits,
            vesselLimits: item.vesselLimits,
            isExcluded: isExcluded,
            isBypassed: isBypassed,
            isSelected: (this.selectedSegment?.id == item.id) || (item.group && this.selectedSegment?.group == item.group)
          }
        }
      );
    },
  },
  methods: {
    fitToScreen() {
      routes_map.fitBounds();
    },
    saveData() {
      if (!this.routesStore.generalRoute?.data) return;
      const filename = prompt('Enter filename to save:', 'general-route');
      if (!filename) return;

      exportJSON(
        {
          ...this.routesStore.generalRoute.data,
          excludedZones: this.routesStore.generalRoute.excludedZones || []
        }, 
        filename
      );
    },
    loadData() {
      this.$refs.fileInput.click();
    },
    clearData() {
      if (!confirm(this.$t('map.clearRoutePrompt'))) return;
      
      routes_map.clearRoute();
      routes_map.clearGeneralRoute();
      routes_map.drawMapLayers();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);

          if (confirm(this.$t('editor.loadingWarning'))) {
            routes_map.clearRoute();
            routes_map.clearGeneralRoute();

            this.routesStore.setGeneralRoute(data);
            this.routesStore.setPreviewExcludedZones(data.excludedZones || []);

            // copy general route route point to waypoints
            routes_map.makeWaypointsFromGeneralRoute();
            routes_map.drawMapLayers();
            routes_map.fitBounds();
          }
        } catch (error) {
          alert('Error loading file: ' + error.message);
        }

        // Reset file input
        this.$refs.fileInput.value = '';
      };

      reader.readAsText(file);
    },
    scrollToSelectedItem() {
      const allItems = this.items;
      const indexOfSelected = allItems.findIndex(i => i.item.id == this.selectedSegment?.id);
      const scrollableParent = document.getElementById('routes-table')?.parentElement;

      if (scrollableParent && indexOfSelected >= 0) {
        scrollableParent.scrollTop = 0;
        const tbody = this.$refs.generalRouteTable.$el.querySelector('tbody');
        const row = tbody.querySelectorAll('tr')[indexOfSelected]
        row?.scrollIntoView?.();

        if (indexOfSelected != allItems.length - 1) {
          // scroll overshoots because of sticky header, retract scroll by header height, which is 50px
          scrollableParent.scrollTop -= 50;
        }
      }
    },    
    setCanUpdate(canUpdate) {
      const routesStore = useRoutesStore();
      routesStore.setGeneralRouteModified(canUpdate);
    },
    updatePreview() {
      routes_map.updateRoute();
      //routes_map.clearRoute();
      //routes_map.clearGeneralRoute();
      this.setCanUpdate(false);
    },
    rowClass(item, type) {
      // if (!item.isDanger || type !== 'row') return
      if (item.isSelected) return 'general-route-selected-row';
    },
    onExcludedRowClicked(row, index) {
      const routesStore = useRoutesStore();
      const excludedZones = routesStore.generalRoute.excludedZones;
      const clickedItem = excludedZones[index];

      if (excludedZones.some(zone => zone.id == clickedItem.id)) {
        routesStore.setPreviewExcludedZones(excludedZones.filter(zone => zone.id !== clickedItem.id));
      } else {
        routesStore.setPreviewExcludedZones([...excludedZones, clickedItem]);
      }
      this.setCanUpdate(true);
    },
    onExcludedZoneClicked(row, index) {
      const clickedItem = row.segment;

      if (!clickedItem.points) return;

      routes_map.map.setView(
        [clickedItem.points[0].lat, clickedItem.points[0].lon], 
        routes_map.map.getZoom(), // what value to zoom in? tried 100, tried 1000000.
        {animate: false}
      );
    },
    onRowGroupClicked(row, index) {
      const routesStore = useRoutesStore();
      const excludedZones = routesStore.generalRoute.excludedZones;

      const clickedItem = row.item;
      /*
      const clickedItem = routesStore
        .generalRoute
        .data
        .lines[index];
      */

      // ignore generic segments
      //if (!clickedItem.group || clickedItem.group === "") return;
      
      const excludedGroup = clickedItem.group || "";

      if (excludedZones.some(zone => (zone.group && zone.group != "" && zone.group == excludedGroup) || zone.id == clickedItem.id)) {
        routesStore.setPreviewExcludedZones(excludedZones.filter(zone => {
          if (zone.group && zone.group != "" && zone.group == excludedGroup)
            return false;

          if (zone.id == clickedItem.id)
            return false;

          return true;
        }));
      }
      else {
        routesStore.setPreviewExcludedZones([...excludedZones, clickedItem]);
      } 

      this.setCanUpdate(true);
    },
    onRowNameClicked(row, index) {
      const clickedItem = row.item;

      if (!clickedItem.points) return;

      routes_map.map.setView(
        [clickedItem.points[0].lat, clickedItem.points[0].lon], 
        routes_map.map.getZoom(), // what value to zoom in? tried 100, tried 1000000.
        {animate: false}
      );

      this.selectedSegment = clickedItem;
    }
  }
}
</script>

<style scoped>
.vessel-limits {
  color: black;
}
/deep/  .vessel-limits > table > tbody > tr > td {
    padding: 0px;
  }

  /deep/  .vessel-limits > table > tbody > tr > td:last-child {
    text-align: right;
  }
</style>